import { Box, Divider, Drawer, Typography } from "@mui/material";

import { styled } from "@mui/material/styles";
import { NetworkIcon, PlusIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { can } from "authorization/authorization.util";
import { ZonePermissionEnum } from "authorization/types";
import { DynamicButton } from "components/DynamicButton/DynamicButton";
import { useAuthenticatedUser } from "hooks/useAuthenticatedUser";
import { IZone } from "interfaces/zone.interface";

import { ZoneMenu } from "./ZoneMenu";

const drawerWidth = 330;

const PermanentDrawer = styled(Drawer)(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  zIndex: theme.zIndex.appBar - 1,
  "& .MuiDrawer-paper": {
    width: drawerWidth,
    boxSizing: "border-box",
  },
}));

type ZoneSidebarProps = {
  zones: IZone[];
};

export const ZoneSidebar = ({ zones }: ZoneSidebarProps) => {
  const { t } = useTranslation();
  const { permissions } = useAuthenticatedUser();

  const canCreateZone = can(permissions, ZonePermissionEnum["zone.create"]);

  return (
    <PermanentDrawer variant="permanent">
      <Box sx={{ paddingTop: "55px" }} />
      <Box
        sx={{
          display: "flex",
          padding: 2,
          gap: 1,
          alignItems: "center",
          height: 68,
        }}
      >
        <NetworkIcon />
        <Typography variant="inherit">{t("Zones")}</Typography>
        <Box sx={{ flexGrow: 1 }} />
        {canCreateZone && (
          <DynamicButton
            href={"/administration/create-zone"}
            startIcon={<PlusIcon />}
            variant={"text"}
          >
            {t("create_zone")}
          </DynamicButton>
        )}
      </Box>
      <Divider />
      <Box sx={{ padding: 1, overflow: "auto" }}>
        <ZoneMenu zones={zones} />
      </Box>
    </PermanentDrawer>
  );
};
